import React, { useContext, useMemo } from "react";
import { FilteredTracksContext } from "~/Context/FilteredTracksContext";
import { ImportContext } from "~/Context/ImportContext";
import Typo from "Trackalyze/Typo";
import { useTranslation } from "react-i18next";

import Flex from "Trackalyze/Flex";
import CheckBox from "Trackalyze/CheckBox";
import List, { ListItem } from "Trackalyze/List";

const FilterGroupsContent = (props) => {
  const { t } = useTranslation();

  const {
    filterGroups,
    setFilterGroups,
    filterActivities,
    filterWaypoints,
    filterGpxTypes,
    filterFavorites,
    handleFilterTracks,
    searchQuery,
  } = useContext(FilteredTracksContext);

  const { tracksIndex, trackGroups } = useContext(ImportContext);

  const toggleGroupFilter = (groupId) => {
    setFilterGroups((prevFilter) => {
      if (prevFilter.includes(groupId)) {
        return prevFilter.filter((id) => id !== groupId);
      } else {
        return [...prevFilter, groupId];
      }
    });
  };

  // Calculate tracks filtered by other filters
  const tracksFilteredByOthers = useMemo(() => {
    return handleFilterTracks(
      tracksIndex,
      filterActivities,
      filterWaypoints,
      filterFavorites || [], // favorites
      filterGpxTypes,
      [], // Exclude current filter type (groups)
      searchQuery,
    );
  }, [
    tracksIndex,
    filterActivities,
    filterWaypoints,
    filterFavorites,
    filterGpxTypes,
    handleFilterTracks,
    searchQuery,
  ]);

  const groupOptions = useMemo(() => {
    if (!tracksIndex || !trackGroups || !tracksFilteredByOthers) return [];

    return trackGroups.map((ctxGroup) => {
      const relatedTracksCount = tracksIndex.filter(
        (t) => t["info.groupId"] === ctxGroup.id,
      ).length;
      const filteredTracksCount = tracksFilteredByOthers.filter(
        (t) => t["info.groupId"] === ctxGroup.id,
      ).length;

      return {
        ...ctxGroup,
        totalCount: relatedTracksCount,
        count: filteredTracksCount,
      };
    });
  }, [tracksIndex, tracksFilteredByOthers, trackGroups]);

  const availableOptions = useMemo(() => {
    return groupOptions.filter((group) => {
      const isSelected = filterGroups.includes(group.id);
      return group.count > 0 || isSelected;
    });
  }, [groupOptions, filterGroups]);

  if (!props.standalone && availableOptions.length === 0) return null;

  return (
    <>
      <List segmented level="2">
        {availableOptions.length > 0 ? (
          availableOptions.map((group, idx) => {
            const isSelected = filterGroups.includes(group.id);
            return (
              <ListItem key={idx}>
                <Flex
                  itemscenter
                  spacing="5"
                  onClick={() => toggleGroupFilter(group.id)}
                >
                  <Typo className="ta-flexitem" noWrap>
                    {group.name} ({group.count})
                  </Typo>
                  <CheckBox
                    name="group"
                    value={group.id}
                    checked={isSelected ? group.id : ""}
                  />
                </Flex>
              </ListItem>
            );
          })
        ) : (
          <Typo className="ta-color-text_on-surface-lower" size="s">
            {t("trackManager.filterNoresult")}
          </Typo>
        )}
      </List>
    </>
  );
};

export default React.memo(FilterGroupsContent);
